import { LoggerService } from '../../../../core/logger.service';
import { SyncCryptService } from '../../../../core/crypt/sync-crypt.service';
import { Subscription } from 'rxjs';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { environment } from '../../../../../environments/environment';
import * as fromRoot from '../../../../reducers';
import { User } from '../../../models';

export interface IFrameMessage {
    data: any;
    action: string;
}

@Component({
    selector: 'sync-comment-cp-iframe',
    templateUrl: './comment-cp-iframe.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class CommentCpIFrameComponent implements OnInit, OnDestroy {
    private parent = window.parent;
    private sub: Subscription;
    private linkHost: string;

    constructor(
        private store: Store<fromRoot.State>,
        private crypt: SyncCryptService,
        private log: LoggerService
    ) {}

    ngOnInit() {
        //this.linkHost must be the same as parent's host
        const parentHost =
            document.location.ancestorOrigins &&
            document.location.ancestorOrigins.length
                ? document.location.ancestorOrigins[0]
                : document.referrer;
        if (parentHost) {
            //firefox's referer is not the same as that of chrome...
            if (parentHost.indexOf('https://ln.sync.com') === 0) {
                this.linkHost = 'https://ln.sync.com';
            } else if (parentHost.indexOf('https://ln2.sync.com') === 0) {
                this.linkHost = 'https://ln2.sync.com';
            } else if (parentHost.indexOf('https://ln3.sync.com') === 0) {
                this.linkHost = 'https://ln3.sync.com';
            } else if (parentHost.indexOf('https://ln4.sync.com') === 0) {
                this.linkHost = 'https://ln4.sync.com';
            } else if (parentHost.indexOf('https://ln5.sync.com') === 0) {
                this.linkHost = 'https://ln5.sync.com';
            } else if (parentHost.indexOf('https://ln6.sync.com') === 0) {
                this.linkHost = 'https://ln6.sync.com';
            } else if (parentHost.indexOf('https://ln7.sync.com') === 0) {
                this.linkHost = 'https://ln7.sync.com';
            } else {
                this.linkHost = environment.linkhost.replace(/\/+$/, ''); //strip trailing slashes
            }
        } else {
            this.linkHost = environment.linkhost.replace(/\/+$/, ''); //strip trailing slashes
        }
        this.log.info('comment-iframe init ' + this.linkHost);

        window.addEventListener('message', this.handleIFrameMessage.bind(this));
        //send user object to link domain
        this.sub = this.store
            .pipe(select(fromRoot.getAuthUser))
            .subscribe((data) => {
                this.sendMessage('update-user', data);
            });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    private async handleIFrameMessage(e: MessageEvent) {
        if (!e.origin.startsWith(this.linkHost)) {
            // commenting this error to reduce the noice
            // this.log.error(
            //     `linkhost origin mismatched - sender host: ${e.origin}, env host: ${this.linkHost}. No message sent`
            // );
            return;
        }
        switch (e.data.action) {
            case 'sign':
                const signedInput = await this.crypt.signApiReq(e.data.data);
                this.sendMessage('signed', signedInput);
                break;
        }
    }

    public sendMessage(action: string, data: any) {
        this.parent.postMessage({ action: action, data: data }, this.linkHost);
    }
}
